import type { CSSProperties } from "react";

import styles from "./TextAreaInput.module.scss";

interface TextAreaInputProps {
  id: string;
  value: string;
  placeholder?: string;
  readonly?: boolean;
  outline?: string;
  textStyle?: CSSProperties;
  onChange: (value: string) => void;
}

export function TextAreaInput({
  id,
  value,
  placeholder,
  readonly,
  textStyle,
  onChange,
}: TextAreaInputProps) {
  const inlineStyle: CSSProperties = {
    ...textStyle,
  };

  return (
    <textarea
      id={id}
      className={styles.textarea}
      style={inlineStyle}
      value={value}
      placeholder={placeholder}
      readOnly={readonly}
      onChange={e => onChange(e.target.value)}
      rows={3}
    />
  );
}
